import { Download, Package, FileCode, Server, Database, CheckCircle } from 'lucide-react';
import { Button } from '../components/ui/button';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const DownloadPage = () => {
  const handleDownload = () => {
    window.location.href = `${BACKEND_URL}/api/download`;
  };

  const fileStructure = [
    { name: 'frontend/', description: 'React application', icon: FileCode },
    { name: '├── src/components/', description: 'All UI components', icon: Package },
    { name: '├── src/App.js', description: 'Main app entry', icon: FileCode },
    { name: '├── tailwind.config.js', description: 'Tailwind configuration', icon: FileCode },
    { name: '└── package.json', description: 'Dependencies', icon: Package },
    { name: 'backend/', description: 'FastAPI server', icon: Server },
    { name: '├── server.py', description: 'API endpoints', icon: FileCode },
    { name: '├── requirements.txt', description: 'Python dependencies', icon: Package },
    { name: '└── .env', description: 'Environment variables', icon: Database },
  ];

  const deploySteps = [
    'Giải nén file ZIP',
    'Frontend: chạy "yarn install" rồi "yarn build"',
    'Upload thư mục "build" lên hosting (Netlify, Vercel, hoặc shared hosting)',
    'Backend: cài đặt trên VPS với Python + MongoDB',
    'Cập nhật REACT_APP_BACKEND_URL trong frontend/.env',
  ];

  return (
    <div className="min-h-screen bg-coastal-offwhite py-20">
      <div className="max-w-4xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="w-20 h-20 bg-coastal-navy rounded-2xl flex items-center justify-center mx-auto mb-6">
            <Download className="w-10 h-10 text-white" />
          </div>
          <h1 className="font-heading text-4xl md:text-5xl font-bold text-coastal-navy mb-4">
            Download Project
          </h1>
          <p className="text-lg text-gray-600">
            Tải xuống mã nguồn Coastal Route Commerce
          </p>
        </div>

        {/* Download Card */}
        <div className="bg-white rounded-3xl p-8 md:p-10 border border-gray-200 shadow-xl mb-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6 mb-8">
            <div>
              <h2 className="font-heading text-2xl font-bold text-coastal-navy mb-2">
                coastal-route-commerce.zip
              </h2>
              <p className="text-gray-600">
                Bao gồm Frontend (React) + Backend (FastAPI) + Configurations
              </p>
            </div>
            <Button
              onClick={handleDownload}
              className="bg-coastal-orange hover:bg-coastal-orange/90 text-white rounded-full px-8 py-6 text-lg font-semibold transition-all hover:-translate-y-1 shadow-lg hover:shadow-xl flex items-center gap-3"
            >
              <Download className="w-6 h-6" />
              Tải xuống ZIP
            </Button>
          </div>

          {/* File Structure */}
          <div className="border-t border-gray-200 pt-6">
            <h3 className="font-heading font-semibold text-coastal-navy mb-4">
              Cấu trúc thư mục:
            </h3>
            <div className="bg-coastal-offwhite rounded-xl p-4 font-mono text-sm">
              {fileStructure.map((item, index) => {
                const Icon = item.icon;
                return (
                  <div key={index} className="flex items-center gap-3 py-1.5">
                    <Icon className="w-4 h-4 text-coastal-orange flex-shrink-0" />
                    <span className="text-coastal-navy">{item.name}</span>
                    <span className="text-gray-400 text-xs">— {item.description}</span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        {/* Deploy Instructions */}
        <div className="bg-white rounded-3xl p-8 md:p-10 border border-gray-200 shadow-lg">
          <h2 className="font-heading text-2xl font-bold text-coastal-navy mb-6">
            Hướng dẫn Deploy lên Hosting
          </h2>
          
          <div className="space-y-4">
            {deploySteps.map((step, index) => (
              <div key={index} className="flex items-start gap-4">
                <div className="w-8 h-8 bg-coastal-orange/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="font-heading font-bold text-coastal-orange">
                    {index + 1}
                  </span>
                </div>
                <p className="text-gray-700 pt-1">{step}</p>
              </div>
            ))}
          </div>

          <div className="mt-8 p-4 bg-coastal-navy/5 rounded-xl">
            <div className="flex items-start gap-3">
              <CheckCircle className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
              <div>
                <p className="font-semibold text-coastal-navy">Lưu ý cho Static Hosting:</p>
                <p className="text-gray-600 text-sm mt-1">
                  Nếu chỉ cần landing page tĩnh, bạn chỉ cần upload thư mục <code className="bg-gray-200 px-1 rounded">frontend/build</code> lên hosting. 
                  Backend chỉ cần thiết nếu muốn lưu form liên hệ vào database.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Back to Home */}
        <div className="text-center mt-8">
          <a
            href="/"
            className="inline-flex items-center gap-2 text-coastal-navy font-semibold hover:text-coastal-orange transition-colors"
          >
            ← Quay lại trang chủ
          </a>
        </div>
      </div>
    </div>
  );
};

export default DownloadPage;
